import React, { useState, useRef } from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import moment from "moment";
import { apiUrl } from "features/configure";
import axios from "axios";

import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import { selectEcosystemList } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { PopperMenu } from "@metacrm/metacrm-material-ui/dist/PopperMenu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import { useOutletContext } from "react-router";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useConfirm } from "features/home/ConfirmDialogProvider";
import { useIntl } from "react-intl";
import useGetPagePermission from "hooks/useGetPagePermission";
import {
  formatDate,
  getChainList,
  getEcosystemName,
} from "features/helpers/utils";

const getChainNameById = (chainList, id) => {
  const chain = chainList.find((chain) => chain.id === id);
  return chain ? chain.name : null; // 如果找到則返回 name，否則返回 null
};

const getChainLogo = (chainList, id) => {
  const chain = chainList.find((chain) => chain.id === id);
  return chain ? chain.logo_url : null; // 如果找到則返回 name，否則返回 null
};

const getEcosystemNameById = (ecosystemList, id) => {
  const ecosystem = ecosystemList.find((ecosystem) => ecosystem.id === id);
  return ecosystem ? ecosystem.name : null; // 如果找到則返回 name，否則返回 null
};

const getEcosystemLogo = (ecosystemList, id) => {
  const ecosystem = ecosystemList.find((ecosystem) => ecosystem.id === id);
  return ecosystem ? ecosystem.logo_url : null; // 如果找到則返回 name，否則返回 null
};

const ContractItem = ({ contractInfo }) => {
  const theme = useTheme();
  const chainList = getChainList();
  const ecosystemList = useSelector(selectEcosystemList);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const confirm = useConfirm();
  const { formatMessage } = useIntl();
  const pagePermission = useGetPagePermission();
  const { canEdit } = pagePermission("webTraffic");

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        background: theme.customColors.white,
        height: "100%",
        borderRadius: "8px",
        position: "relative",
        minHeight: "214px",
        boxShadow: "2px 2px 8px 0px #0000001A",
        padding: "20px 16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box mb={2} sx={{ fontWeight: "700" }}>
          <Box
            sx={{
              fontSize: "12px",
              color: theme.customColors.grey[600],
              marginBottom: "8px",
            }}
          >
            {formatMessage({
              id: "global.labelName.name",
            })}
          </Box>
          <Box sx={{ color: theme.customColors.purple[500] }}>
            {contractInfo?.name}
          </Box>
        </Box>

        <Box mb={2}>
          <Box
            sx={{
              fontSize: "12px",
              color: theme.customColors.grey[600],
              marginBottom: "4px",
            }}
          >
            {formatMessage({
              id: "global.commonWord.ecosystem",
            })}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              color: theme.customColors.grey[700],
            }}
          >
            <Box
              component="img"
              width="18px"
              height="18px"
              mr="4px"
              src={getEcosystemLogo(ecosystemList, contractInfo?.ecosytem)}
            ></Box>
            {getEcosystemNameById(ecosystemList, contractInfo?.ecosytem)}
          </Box>
        </Box>

        <Box mb={2}>
          <Box
            sx={{
              fontSize: "12px",
              color: theme.customColors.grey[600],
              marginBottom: "4px",
            }}
          >
            {formatMessage({
              id: "global.chain",
            })}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              color: theme.customColors.grey[700],
            }}
          >
            <Box
              component="img"
              width="18px"
              height="18px"
              mr="4px"
              src={getChainLogo(chainList, contractInfo?.chainId)}
            ></Box>
            {getChainNameById(chainList, contractInfo?.chainId)}
          </Box>
        </Box>
        <Box mb={2}>
          <Box
            sx={{
              fontSize: "12px",
              color: theme.customColors.grey[600],
              marginBottom: "4px",
            }}
          >
            {formatMessage({
              id: "global.contract.address",
            })}
          </Box>
          <Box
            sx={{
              color: theme.customColors.grey[700],
              wordBreak: "break-all",
            }}
          >
            {contractInfo?.contractAddress}
          </Box>
        </Box>

        <Box
          sx={{
            fontSize: "10px",
            color: theme.customColors.grey[500],
          }}
        >
          {formatDate(contractInfo?.updated)}
        </Box>
      </Box>
    </Box>
  );
};

export default ContractItem;
